import AuthDatas from "./auth";
import { combineReducers } from "redux";

export default combineReducers({ AuthDatas });
